export const currency = (val) => {
    let getCurrency: any = window.localStorage.getItem('currency')
    if (!getCurrency || getCurrency === '') {
        getCurrency = 'GBP'
    }

    if (typeof val === 'number') {
        return `${getCurrency} ${val.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
    } else {
        return `${getCurrency} ${val}`
    }
}

export const symbol = () => {
    if (window.localStorage) {
        let getCurrency: any = window.localStorage.getItem('currency')
        if (!getCurrency || getCurrency === '') {
            getCurrency = 'GBP'
        }
        return getCurrency
    }
    return 'GBP'
}

export const settlementBasisCalc = (settlementBasis) => {
    let result = (settlementBasis - 1) * 100

    return (result >= 0) ? `+ ${Math.round(result)}` : Math.round(result)
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/CurrencyFormat.tsx